<div class="mainDarkBlueCard">
    <div class="stat-widget-header">
        <h4 class="normalFontWeight">
            {{ "CARE_RECIPIENTS" | translate }}
        </h4>
    </div>

    <h2 id="recipientCount">{{ careRecipientCount }}</h2>
</div>
